import { Flex, Button, Heading, Text, VStack } from '@chakra-ui/react';
import { useScreenWidth } from 'hooks/useScreenWidth';
import toast from 'react-hot-toast';
import Modal from 'react-modal';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const OrderCompleteModal = ({ isOrderModalOpen, closeOrderModal, id, closeModal }) => {
    const navigate = useNavigate();
    const screen = useScreenWidth();

    return (
        <Modal
            isOpen={isOrderModalOpen}
            onRequestClose={() => {
                closeModal();
                closeOrderModal();
            }}
            className="Modal"
            overlayClassName="Overlay">
            <Container>
                <Heading as="h4" textAlign="center" fontSize="24px" mt="20px">
                    Thank You!
                </Heading>
                <Flex
                    borderRadius="10px"
                    w="320px"
                    h="270px"
                    mt="30px"
                    mx="auto"
                    justify="center"
                    align="center"
                    direction="column">
                    <VStack fontWeight="400" mb="1.2rem" style={{ lineHeight: '12px' }}>
                        <Text>Obana Store One</Text>
                        <Text>for your purchase</Text>
                    </VStack>
                    <VStack fontWeight="400" mb="1.2rem" style={{ lineHeight: '16px' }}>
                        <Text textAlign="center" mt="15px">
                            Your order number is: {id}
                        </Text>
                    </VStack>
                    <VStack
                        fontWeight="400"
                        mb="1.2rem"
                        w="100"
                        style={{ width: '100%', lineHeight: '12px' }}>
                        <Text textAlign="center">We&apos;ll email</Text>
                        <Text textAlign="center">you an order confirmation with details and</Text>
                        <Text textAlign="center">tracking info</Text>
                    </VStack>
                </Flex>
                <VStack mt="20px">
                    <Button
                        w="100%"
                        color="#F5F5F5"
                        bg="#1b3b5f"
                        mt="15px"
                        fontWeight="400"
                        borderRadius="48px"
                        h="48px"
                        outline="none"
                        onClick={() => {
                            closeOrderModal();
                            // navigate(`/`, { replace: true });
                            navigate(screen > 500 ? `/dashboard` : `/dashboard`, {
                                replace: true,
                            });
                        }}>
                        Continue Shopping
                    </Button>
                    <Button
                        w="100%"
                        color="#202325"
                        bg="white"
                        mt="15px"
                        fontWeight="400"
                        borderRadius="48px"
                        outline="none"
                        onClick={() => {
                            closeOrderModal();
                            toast.success('Order Placed', { position: 'top-right' });
                            setTimeout(() => {
                                navigate(screen > 500 ? `/dashboard/logout` : `/logout`, {
                                    replace: true,
                                });
                            }, 2000);
                        }}>
                        Logout From Obana
                    </Button>
                </VStack>
                <OrderCompleteModal />
            </Container>
        </Modal>
    );
};

export default OrderCompleteModal;

const Container = styled.div`
    width: 380px;
    max-height: 100%;
    background: #ffffff;
    border-radius: 16px 16px 16px 16px;
    padding: 24px 24px;
    padding-bottom: 50px;

    @media screen and (max-width: 500px) {
        padding: 18px 18px;
        width: 100vw;
        max-height: 100%;
        background: #ffffff;
        border-radius: 16px 16px 0px 0px;
    }
    a {
        width: 95%;
        border-radius: 5px;
        padding: 4px;
        height: 44px;
        font-size: 20px;
    }
    .active-link {
        background: rgba(33, 33, 241, 0.1);
        color: #1b3b5f;
        font-weight: 700;
        svg {
            path {
                stroke: #1b3b5f;
            }
        }
    }
`;
